import React from 'react';
import { LobsterHerringSupplySlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'herring-supply';
const SLUG_DB = 'herring-supply-db';

const DEFAULT_HERRING_SUPPLY = [6741, 10885, 15435];

interface HerringSupplyData {
  projectionYears?: number;
  projectionYearsLobster?: number;
  disabled?: boolean;
  lobsterDisabled?: boolean;
}

export default function HerringSupply(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<HerringSupplyData>(props);

  const formValues = formContext?.values?.[SLUG] as number[] | undefined;
  const formDbValues = formContext?.values?.[SLUG_DB] as number[] | undefined;
  const herringSupply = formValues ?? DEFAULT_HERRING_SUPPLY;
  const dbHerringSupply = formDbValues ?? herringSupply;
  const rawProjectionYears =
    data.projectionYears ??
    data.projectionYearsLobster ??
    formContext?.values?.['lobster-projection-years'] ??
    3;
  const projectionYears = Array.isArray(rawProjectionYears)
    ? (rawProjectionYears.length > 0 ? rawProjectionYears.length : 3)
    : (typeof rawProjectionYears === 'number' ? rawProjectionYears : 3);
  const disabled = data.disabled ?? data.lobsterDisabled ?? false;

  const handleChange = React.useCallback(
    (updatedValues: number[]) => {
      formContext?.setValue(SLUG, updatedValues);
    },
    [formContext]
  );

  return (
    <LobsterHerringSupplySlider
      herringSupply={Array.isArray(herringSupply) ? herringSupply : DEFAULT_HERRING_SUPPLY}
      dbHerringSupply={Array.isArray(dbHerringSupply) ? dbHerringSupply : []}
      projectionYears={projectionYears}
      projectionStartYear={2026}
      onChange={handleChange}
      disabled={disabled}
    />
  );
}
